import React from 'react';
import { BookOpen } from 'lucide-react';
import { useScreenInit } from '../useScreenInit';
export function Training() {
  useScreenInit();
  return <div className="flex flex-col items-center justify-center min-h-[80vh] p-6 text-center" data-id="element-515">
      <div className="w-20 h-20 bg-brand-primary/10 rounded-full flex items-center justify-center mb-6" data-id="element-516">
        <BookOpen className="w-10 h-10 text-brand-primary" data-id="element-517" />
      </div>
      <h1 className="text-2xl font-bold text-text-primary mb-2" data-id="element-518">
        Training Center
      </h1>
      <p className="text-text-secondary max-w-xs" data-id="element-519">
        Access courses on entrepreneurship, agriculture, and financial literacy.
        Coming soon!
      </p>
    </div>;
}